import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function MPLimitSelector({attr, additionalOptions, primaryOptions, otherOptions, dataType, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  let medicalPaymentInd = line.medicalPaymentInd;
  
  let limit2000 = {value:"2000", name:"$2,000"};
  let limit5000 = {value:"5000", name:"$5,000"};
  let limit10000 = {value:"10000", name:"$10,000"};
  let limit25000 = {value:"25000", name:"$25,000"};
  
  let lineOptions = [limit2000, limit5000, limit10000, limit25000];
  if(primaryOptions) {
    lineOptions = primaryOptions;
  }

  if(props.exceptedVehicles){
    const risks = applicationModel.getValue('lines[0].risks');
    let applicableVehicles = risks ? risks.filter(risk => {
      return risk.status === 'Active' && !["Motorcycle", "Snowmobile", "Vintage Tractor"].includes(risk.vehicle.typeCd);
    }) : [];
    if (applicableVehicles.length == 0) {
      lineOptions = [limit2000];
    }
  }

  if(line.mPLimit == ""){
    line.mPLimit = "2000";
    props.value = "$2,000";
  }
  
  if (!medicalPaymentInd) {
      if (otherOptions){
        lineOptions = otherOptions;
      } else {
        lineOptions = [limit2000];
      }
  }

  
  if (additionalOptions && additionalOptions.length) {
    lineOptions = [...lineOptions, ...additionalOptions];
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });
    
    const form = useContext(FormContext);
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = form;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    
    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);
      actions.saveApplication();
    };
    return <Select
        {...props}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

MPLimitSelector.schema = BASIC_ELEMENT_SCHEMA;